'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import uiBootstrap from 'angular-ui-bootstrap';
import windowService from './windows.service';

export class WindowComponent {

  constructor(WindowService) {
    'ngInject';

    Object.defineProperty(this, 'windows', {
      get: () => {
        return WindowService.getItems();
      }
    });
  }
}

export default angular.module('directives.windows', [uiBootstrap, windowService])
  .component('windows', {
    template: require('./windows.html'),
    controller: WindowComponent,
    controllerAs: 'windowsCtrl',
    transclude: true
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/windows/windows.component.js